import axios from 'axios';

import { API_HOST, API_VERSION } from 'constants/env';

axios.defaults.baseURL = `${API_HOST}/${API_VERSION}`;

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
